import React from 'react';

export default function SegmentedControl({ options, active, onChange }) {
  return (
    <div className="flex w-full sm:w-max items-center gap-0.5 bg-[#0d0d0d] border border-[#222222] rounded-full p-1">
      {options.map((opt) => {
        const isActive = active === opt;
        return (
          <button
            key={opt}
            onClick={() => onChange(opt)}
            className={`flex-1 sm:flex-none px-1 sm:px-3.5 py-1.5 rounded-full text-[11px] sm:text-xs font-semibold tracking-wide transition-all duration-150 ${
              isActive
                ? 'bg-white text-black'
                : 'text-muted hover:text-white'
            }`}
          >
            {opt}
          </button>
        );
      })}
    </div>
  );
}